import {Alert, Anchor, Fieldset, Text, TextInput} from '@mantine/core'
import {ProjectSelect} from '../../../calendar/components/ProjectSelect.tsx'
import {NoProjectWarning} from '../../components/NoProjectWarning.tsx'
import {IconInfoCircle} from '@tabler/icons-react'
import {WorkweekView} from '../../../projects/forms/workweek/WorkweekView.tsx'
import {useProject} from '../../../../providers/projects/useProject.ts'
import type {FormValues} from './FormValues.ts'
import type {UseFormReturnType} from '@mantine/form'

type Props = {
  form: UseFormReturnType<FormValues>
  apiKeyDisabled: boolean
  disabled: boolean
}

export const FormFields = ({form, apiKeyDisabled, disabled: containerDisabled}: Props) => {
  const project = useProject(form.values.projectId || null)

  const disabled = containerDisabled

  return (
    <>
      <Fieldset legend={'General'}>
        <TextInput
          label={'Name'}
          key={form.key('name')}
          {...form.getInputProps('name')}
          style={{minWidth: 325}}
          required
          disabled={disabled}
        />
        <ProjectSelect
          key={form.key('projectId')}
          {...form.getInputProps('projectId')}
          value={form.values.projectId}
          onChange={(projectId) => form.setFieldValue('projectId', projectId)}
          disabled={disabled}
        />
        {!form.values.projectId && <NoProjectWarning />}

        {form.values.projectId && (
          <Alert variant={'light'} color={'blue'} icon={<IconInfoCircle stroke={1} />}>
            <Text size={'sm'}>Recommendations will only be generated within the configured workweek:</Text>
            <WorkweekView value={project?.workdays} c={'dimmed'} size={'sm'} />
          </Alert>
        )}
      </Fieldset>

      <Fieldset legend={'Jira'}>
        <TextInput
          label={'Jira domain'}
          placeholder={'https://<your-subdomain>.atlassian.net'}
          key={form.key('domain')}
          {...form.getInputProps('domain')}
          style={{minWidth: 325}}
          required
          disabled={disabled}
        />
        <TextInput
          label={'Email'}
          type={'email'}
          key={form.key('username')}
          {...form.getInputProps('username')}
          style={{minWidth: 325}}
          required
          disabled={disabled}
        />
        <TextInput
          label={'Api Token'}
          description={
            <Anchor href={'https://id.atlassian.com/manage-profile/security/api-tokens'} size={'xs'} target={'_blank'}>
              Manage Atlassian API Tokens
            </Anchor>
          }
          key={form.key('apiKey')}
          placeholder={'ATATT...'}
          {...form.getInputProps('apiKey')}
          style={{minWidth: 325}}
          required
          disabled={disabled || apiKeyDisabled}
        />
        <TextInput
          label={'Project key'}
          placeholder={'PROJ'}
          key={form.key('projectKey')}
          {...form.getInputProps('projectKey')}
          style={{minWidth: 325}}
          required
          disabled={disabled}
        />
      </Fieldset>
    </>
  )
}
